const STORAGE_KEY = 'showoff';
const GETTER_NOT_ACCESSIBLE = 'GETTER_NOT_ACCESSIBLE';

export const getShowoffValue = (isAndroidWrapper: boolean): string | null => {
  try {
    if (isAndroidWrapper) {
      return window.AndroidWrapper?.getPreference?.(STORAGE_KEY) ?? null;
    }
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return GETTER_NOT_ACCESSIBLE;
  }
};

export const setShowoffValue = (
  value: string,
  isAndroidWrapper: boolean,
): void => {
  if (isAndroidWrapper) {
    window.AndroidWrapper?.savePreference?.(STORAGE_KEY, value);
    return;
  }
  localStorage.setItem(STORAGE_KEY, value);
};

export const isStorageAccessible = (value: string | null): boolean =>
  value !== GETTER_NOT_ACCESSIBLE;
